import React from 'react';

const UserReferralRewardFormModal = React.lazy(() => import('../components/FormModal'));
const userReferralRewardModalRegistry = {
    core_userReferralRewardId: UserReferralRewardFormModal
};
export default userReferralRewardModalRegistry;
